module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":{"edit":"Modify Review","delete":"Delete Review"},"password":{"placeholder":"Please enter the password you set when you wrote the review.","invalid":"The password does not match. Please re-enter"},"submit":{"edit":"Modify Review","delete":"Delete Review"}}}')
  delete Component.options._Ctor
}
